export default {
    methods: {
        openModal(name, data) {
            this[`is${name}ModalOpened`] = true

            if (data) {
                this[`${name}ModalData`] = data
            }
        },
        closeModal(name) {
            this[`is${name}ModalOpened`] = false

            if (this.hasOwnProperty(`${name}ModalData`)) {
                this[`${name}ModalData`] = null
            }
        }
    }
}
